import React from 'react';
import { STATE_META, stateLabel } from '@/lib/readiness';

const TONE = { done: 'text-emerald-800 border-emerald-300 bg-emerald-50', warn: 'text-amber-800 border-amber-300 bg-amber-50', progress: 'text-sky-800 border-sky-300 bg-sky-50', alert: 'text-red-800 border-red-300 bg-red-50', muted: 'text-muted-foreground border-border bg-muted/40' };

// Text + glyph always present (never colour alone).
export function ReadinessStateBadge({ state, size = 'sm' }) {
  const m = STATE_META[state] || { glyph: '?', tone: 'muted' };
  return (
    <span className={`inline-flex items-center gap-1 rounded-full border px-2 ${size === 'lg' ? 'py-1 text-sm' : 'py-0.5 text-xs'} font-medium ${TONE[m.tone]}`} data-testid="readiness-state" data-state={state}>
      <span aria-hidden="true">{m.glyph}</span>{stateLabel(state)}
    </span>
  );
}

// Accessible progress summary: role=progressbar + visible text; segments are decorative.
export function CoverageBar({ label, percent, partialPercent = 0, available, applicable, testid = 'coverage-bar' }) {
  return (
    <div data-testid={testid}>
      <div className="flex justify-between text-sm mb-1"><span id={`${testid}-label`}>{label}</span><span className="font-medium" data-testid={`${testid}-text`}>{available} of {applicable} applicable outcomes ({percent}%)</span></div>
      <div role="progressbar" aria-labelledby={`${testid}-label`} aria-valuemin={0} aria-valuemax={100} aria-valuenow={percent} aria-valuetext={`${percent}% evidence available, ${partialPercent}% partial or review due`} className="h-3 w-full rounded-full bg-muted overflow-hidden flex">
        <div className="h-full bg-emerald-600" style={{ width: `${percent}%` }} />
        <div className="h-full bg-amber-400 [background-image:repeating-linear-gradient(45deg,transparent_0_4px,rgba(0,0,0,.25)_4px_8px)]" style={{ width: `${partialPercent}%` }} />
      </div>
    </div>
  );
}
